import { ProjectStatusType } from 'src/types'
import { ProjectStatusesResponse } from 'src/types/responses/ProjectStatus'

export const ProjectStatusTranslator = {
  toEntities: (response: ProjectStatusesResponse): ProjectStatusType[] => {
    return response.projectStatuses.map(status => {
      return {
        name: status.name,
        displayName: status.displayName,
        priority: status.priority ?? undefined,
      }
    })
  },
} as const
